// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._19itglyw{border:none}._15k51osq{inline-size:100%}\n._18u0idpf{margin-left:0}\n._19bvidpf{padding-left:0}\n._19pkidpf{margin-top:0}\n._2hwxidpf{margin-right:0}\n._ca0q1b66{padding-top:var(--ds-space-050,4px)}\n._ca0qidpf{padding-top:0}\n._n3tdidpf{padding-bottom:0}\n._otyridpf{margin-bottom:0}\n._u5f3idpf{padding-right:0}", ""]);
// Exports
module.exports = exports;
